import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PayBalance() {
  const { proposalId } = useParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/payments/checkout`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ proposal_id: proposalId, origin_url: window.location.origin, payment_type: 'balance' }),
    })
      .then(r => r.json())
      .then(d => {
        if (d.checkout_url) window.location.href = d.checkout_url;
        else setError(d.detail || 'Could not start checkout');
      })
      .catch(() => setError('Could not start checkout'));
  }, [proposalId]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-6">
      {error ? (
        <p className="text-white/60 text-center" data-testid="pay-balance-error">{error}<br /><span className="text-white/30 text-sm">Contact us if you believe this is a mistake.</span></p>
      ) : (
        <div className="text-center" data-testid="pay-balance-loading">
          <Loader2 className="w-10 h-10 text-gold animate-spin mx-auto mb-4" />
          <p className="text-white/50 text-sm">Opening secure checkout…</p>
        </div>
      )}
    </div>
  );
}
